import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { sophosThrottleEnabled } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "sophosThrottleEnabled",
      defaultChecked: sophosThrottleEnabled == null ? void 0 : sophosThrottleEnabled.value,
      onChange
    }
  ));
};
export default FormAdvancedOptions;
